import { Spacing3Icon, styled } from 'canoe';
import React from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

const VerticalSpaceEvenly = styled(Spacing3Icon)`
  transform: rotate(90deg);
`;

interface Props {
  justifyContent?: string;
  flexDirection?: string;
  toggleValues: (values: Record<string, unknown>) => void;
}

export const JustifySpaceEvenly = ({ justifyContent, flexDirection, toggleValues }: Props) => {
  return (
    <ValueToggle
      toggleGroup="flex-justify"
      id="justify-space-evenly"
      data-cy="toolbox-flex-justify-space-evenly"
      onClick={() =>
        toggleValues({
          justifyContent: 'space-evenly',
        })
      }
      isActive={justifyContent === 'space-evenly'}
      icon={flexDirection === 'row' ? Spacing3Icon : VerticalSpaceEvenly}
      tooltip="Space evenly"
      color="light"
    />
  );
};
